import React from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Section from './Section';
import { Link } from '../util/router';
import './Footer.scss';
import { useLocation } from '../util/router';

function Footer({
  bg = 'dark',
  textColor = 'light',
  bgImage = '',
  bgImageOpacity = 0.8,
  logo = '',
  copyright = ''
}) {
  const location = useLocation();
  const pathsWithoutLogoFooterLayout = ['/auth/signin'];

  return (
    <Section
      bg={bg}
      textColor={textColor}
      size="sm"
      bgImage={bgImage}
      bgImageOpacity={bgImageOpacity}
      className="footer"
    >
      <Container>
        <div className="FooterComponent__inner">
          <div className="brand left">
            {!pathsWithoutLogoFooterLayout.includes(location?.pathname) && (
              <Link to="/">
                <img src={logo} alt="Logo" />
              </Link>
            )}
          </div>
          <div className="links right">
            <Link to="/faq">FAQ</Link>
            <a href="mailto:info@fuelsqc.com" rel="noopener noreferrer">
              Contact
            </a>
          </div>
          <div className="social right" />
          <div className="copyright left">
            {copyright}
            <a
              href="https://www.astm.org/v3/assets/blt5eb0a2cb04534832/blta280cb8c0476ba53/ASTM%20Insight%20SQC%20-%20Terms%20of%20Use.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>
            <Link to="/legal/privacy-policy">Privacy</Link>
          </div>
        </div>
      </Container>
    </Section>
  );
}

Footer.propTypes = {
  bg: PropTypes.string,
  textColor: PropTypes.string,
  bgImage: PropTypes.string,
  bgImageOpacity: PropTypes.number,
  logo: PropTypes.string,
  copyright: PropTypes.string
};

export default Footer;
